export const issueManagerMeilisearchSearchKeyQueryKeys = {
  all: ['issue-manager-meilisearch-search-key'] as const,
  detail: (directoryToken: string) =>
    [...issueManagerMeilisearchSearchKeyQueryKeys.all, directoryToken] as const,
};
